import axios from "axios"

import {generateJwt} from "./utils/auth"


// Web


const serviceGet = async (auth, path, params)=>{

  let headers = {
    // 'Accept': 'application/json',
    // 'Content-Type': 'application/json'
  }

  if(auth.jwtToken){
    headers['Authorization'] = `Bearer ${auth.jwtToken}`

  }else if(auth.userToken){
    headers["Authorization"] = `AUTH-TOKEN ${auth.userToken}`

  }else if(auth.deviceId && auth.deviceToken){
    headers['Authorization'] = `Bearer ${generateJwt(auth.deviceToken, auth.deviceId)}`

  }else {
    throw new Error("Missing authentication")
  }

  return axios.get(`${process.env.REACT_APP_API_URL}${path}`, {
    withCredentials: true,
    headers: headers,
    params
  })


}

const login = async (data)=>{

  return axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, data, {withCredentials: true})

}

const service = {get: serviceGet, login: login}

export default service
